import { render, staticRenderFns } from "./MenuForNode.vue?vue&type=template&id=953ed754&scoped=true"
import script from "./MenuForNode.vue?vue&type=script&lang=js"
export * from "./MenuForNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953ed754",
  null
  
)

export default component.exports